<template>
  <el-row>
    <er-card>
      <er-data-tables
        v-loading="loading"
        :columns="tableColumns"
        :tableData="tableData"
        :el-table-props="tableProps"
        :actionColumn="false"
        type="white-header-table"
        uniqueId="mineral-medicine-table"
        :key="$i18n.locale"
      >
        <template v-slot:resource_name="{ row }">{{
          row.data.resource ? row.data.resource.name : row.data.resource_name
        }}</template>
        <template v-slot:resource_type="{ row }">{{
          resourceTypes[row.data.type]
        }}</template>
        <template v-slot:quantity="{ row }">
          {{ row.data.quantity | numberWithNDigitPrecision(1) }}
          <!-- {{
            row.data.resource
              ? getUnits(row.data.resource.units)
              : getUnits(row.data.units)
          }} -->
        </template>
        <template v-slot:event_date="{ row }">{{
          $moment(row.data.date).format(
            $commonUtils.MOMENT_DATE_FORMAT_WITH_YEAR
          )
        }}</template>
        <template v-slot:actions="{ row }">
          <er-button
            type="text"
            size="mini"
            btnType="edit"
            :showLabel="true"
            :showIcon="true"
            @click="handleEditRecord(row.data)"
            :disabled="clickable"
          ></er-button>
          <el-divider direction="vertical" style="height:100%;"></el-divider>
          <er-button
            type="text"
            size="mini"
            btnType="delete"
            :showLabel="true"
            :showIcon="true"
            @click="handleDeleteRecord(row.data)"
            :disabled="clickable"
          ></er-button>
        </template>
      </er-data-tables>
    </er-card>
    <er-dialog
      :visible.sync="dialogVisible"
      width="25%"
      :close-on-click-modal="false"
      class="pond-input-tab"
      custom-class="pondInput_dialog"
      :title="`${$t('Comn_update')} ${$t('Comn_inputs')}`"
    >
      <el-form size="small" :model="editMedRec" :hide-required-asterisk="true">
        <el-form-item :label="$t('Medicines_variety')" prop="type">
          <el-col :span="22">
            <er-select
              v-model="editMedRec.type"
              size="small"
              @change="handleChangeResourceType($event, 'type', editMedRec)"
              :placeholder="$t('Medicines_variety')"
              disabled
            >
              <el-option
                v-for="(resourceLabel, resourceKey) in resourceTypes"
                :key="resourceKey"
                :value="resourceKey"
                :label="$t(resourceLabel)"
              ></el-option>
            </er-select>
          </el-col>
        </el-form-item>
        <div v-if="editMedRec.type != 'OTHER'">
          <el-form-item :label="$t('Comn_resource')" prop="resource">
            <el-col :span="22">
              <er-select
                v-model="editMedRec.resource._id"
                size="small"
                @change="
                  handleChangeResourceType($event, 'resource', editMedRec)
                "
                :placeholder="$t('Comn_resource')"
              >
                <el-option
                  v-for="resource in getArrResources"
                  :key="resource._id"
                  :value="resource._id"
                  :label="resource.name"
                ></el-option>
              </er-select>
            </el-col>
          </el-form-item>
        </div>
        <div v-else class="others-container">
          <el-form-item
            :label="$t('Comn_resource')"
            :error="castErrorKeyToLang(errMessagesObject.resource_name)"
          >
            <el-col :span="22">
              <el-input
                :placeholder="$t('Comn_others')"
                v-model="editMedRec.resource_name"
                size="small"
              ></el-input>
            </el-col>
          </el-form-item>
        </div>

        <el-form-item
          :label="$t('Comn_quantity')"
          prop="quantity"
          :error="castErrorKeyToLang(errMessagesObject.quantity)"
        >
          <el-col :span="22">
            <el-input-number
              v-model="editMedRec.quantity"
              size="small"
              :controls="false"
              :min="0"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item
          :label="$t('Comn_units')"
          v-if="editMedRec.type === 'OTHER'"
        >
          <el-col :span="22">
            <el-select
              v-model="editMedRec.units"
              size="small"
              :placeholder="$t('Comn_units')"
            >
              <el-option
                v-for="unit in units"
                :key="unit.key"
                :value="unit.key"
                :label="unit.name"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('Comn_units')" v-else>
          <el-col :span="22">
            <el-input
              :value="
                this.editMedRec.units
                  ? unitsObj[this.editMedRec.units]
                  : unitsObj[this.editMedRec.resource.units]
              "
              disabled
              size="small"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('Comn_notes')" prop="notes">
          <el-col :span="22" class="text-input-container">
            <el-input
              size="small"
              type="textarea"
              autosize
              :rows="4"
              :placeholder="$t('Comn_note_here')"
              v-model="editMedRec.notes"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <layout-toolbar slot="footer" justify="center">
        <er-button
          size="mini"
          btnType="save"
          :showLabel="true"
          :showIcon="true"
          :loading="loading"
          @click="decideActionAndPrepPayload()"
          :disabled="isReadOnly"
        ></er-button>
        <er-button
          size="mini"
          btnType="cancel"
          :showLabel="true"
          @click="closeDialogBox"
          :disabled="isReadOnly"
        ></er-button>
      </layout-toolbar>
    </er-dialog>
  </el-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import errorKeyMapMixin from "@/mixins/errorKeyMapMixin";
import filtersMixin from "@/mixins/filtersMixin";
import notificationMixin from "@/mixins/notificationMixin";
export default {
  name: "pondInputTab",
  props: ["tabData"],
  mixins: [
    errorHandlerMixin,
    filtersMixin,
    notificationMixin,
    errorKeyMapMixin
  ],
  data: function() {
    return {
      newErrObject: {
        quantity: {},
        resource_name: {}
      },
      errMessagesObject: {
        quantity: {},
        resource_name: {}
      },
      tableData: [],
      loading: false,
      tableProps: {
        defaultSort: {
          prop: "resource_name"
        }
      },
      dialogVisible: false,
      editMedRec: {
        pond_id: "",
        type: "",
        resource: "",
        quantity: "",
        date: "",
        _id: ""
      },
      units: [
        { name: "Kg", key: "KG" },
        { name: "Lt", key: "L" },
        { name: "Units", key: "UNITS" }
      ],
      unitsObj: {
        KG: "Kg",
        L: "Lt",
        UNITS: "Units"
      },
      backndfieldToFieldNameMap: {
        resource_name: "Comn_resource_name",
        quantity: "Comn_quantity"
      },
      backndfieldToInvalidMap: {
        quantity: {
          VALUE_SHOULD_BE_A_SAFE_NUMBER: 0
        },
        resource_name: {
          INVALID_VALUE: "Resource_can_not_be_empty"
        }
      }
    };
  },
  computed: {
    ...mapGetters("pondDetails", {
      getSelectedPondName: "getSelectedPondName",
      getSelectedPondMedcnsMinrls: "getSelectedPondMedcnsMinrls",
      getCurrentCulture: "getCurrentCulture"
    }),
    ...mapGetters("user", {
      isReadOnly: "isReadOnly",
      getUserCountryCode: "getUserCountryCode"
    }),
    ...mapGetters("resource", {
      getArrResources: "getArrResources"
    }),
    clickable() {
      return !this.isReadOnly && !this.getCurrentCulture.is_running;
    },
    resourceTypes() {
      return {
        MEDICINE: this.$t("Comn_stock_medicine"),
        MINERAL: this.$t("Comn_mineral"),
        PRO_BIOTIC: this.$t("Medicine_pro_biotic"),
        OTHER: this.$t("Comn_others")
      };
    },
    tableColumns() {
      return {
        resource_name: {
          prop: "resource.name",
          label: this.$t("Resource_name"),
          sortable: true,
          minWidth: 100
        },
        resource_type: {
          prop: "type",
          label: this.$t("Resource_resource_type"),
          sortable: true,
          minWidth: 100
        },
        quantity: {
          prop: "quantity",
          label: this.$t("Reports_quantity_applied"),
          sortable: true,
          minWidth: 100
        },
        event_date: {
          prop: "date",
          label: this.$t("Medicines_event_date"),
          sortable: true,
          minWidth: 100
        },
        notes: {
          prop: "notes",
          label: this.$t("Comn_notes"),
          sortable: true,
          minWidth: 100
        },
        actions: {
          prop: "actions",
          label: this.$t("Comn_actions"),
          minWidth: 80
        }
      };
    }
  },
  async mounted() {
    await this.initComponent();
  },
  methods: {
    ...mapActions("pondDetails", {
      fetchResourcesByPondId: "fetchResourcesByPondId"
    }),
    ...mapActions("medicines", {
      addMedicinesToPonds: "addMedicinesToPonds",
      deleteMedicinesAndMineralsInPonds: "deleteMedicinesAndMineralsInPonds"
    }),
    ...mapActions("resource", {
      fetchAllResources: "fetchAllResources"
    }),
    getUnits(unit) {
      return this.units.filter(({ key }) => key === unit)[0].name;
    },
    async initComponent() {
      this.loading = true;
      try {
        await this.fetchResourcesByPondId();
        await this.fetchAllResources({
          type: "MEDICINE",
          include_deleted: true
        });
        this.tableData = this.getSelectedPondMedcnsMinrls;
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    async handleDeleteRecord(record) {
      try {
        this.canUserDelete(this.tabData);
        await this.deleteConfirmation(
          this.$t("Comn_resource"),
          this.$t("Comn_inputs")
        );
        this.loading = true;
        await this.deleteMedicinesAndMineralsInPonds(record._id);
        await this.initComponent();
        this.notifySuccess({
          msgLangkey: {
            title: "Comn_delete_success_msg",
            count: 0,
            child: {
              item: record.resource_name
                ? record.resource_name
                : record.resource.name,
              source: this.getSelectedPondName
            }
          }
        });
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    async handleEditRecord(editMedRec) {
      try {
        this.isEditable(this.tabData);
        this.errMessagesObject = this.$lodash.cloneDeep(this.newErrObject);
        this.dialogVisible = true;
        this.editMedRec = JSON.parse(JSON.stringify(editMedRec));
        await this.fetchAllResources({ type: editMedRec.type });
      } catch (error) {
        this.errorMessages(error, true);
      }
    },
    async decideActionAndPrepPayload() {
      this.loading = true;
      try {
        const {
          pond_id,
          type,
          resource,
          resource_name,
          quantity,
          date,
          _id,
          notes,
          units
        } = this.editMedRec;
        const updatePayload = [];
        const name = resource_name || (resource ? resource.name : "");
        if (resource) {
          updatePayload.push({
            pond_id,
            type,
            resource: resource._id,
            quantity,
            date,
            _id,
            notes
          });
        } else {
          updatePayload.push({
            pond_id,
            type,
            resource_name,
            units,
            quantity,
            date,
            _id,
            notes
          });
        }
        if (!this.editMedRec.resource && !this.editMedRec.resource_name) {
          this.errMessagesObject.resource_name = {
            error_code: "INVALID_VALUE",
            key: "resource_name"
          };
          // return;
        } else if (!quantity || quantity === "0") {
          this.errMessagesObject.quantity = {
            error_code: "VALUE_SHOULD_BE_A_SAFE_NUMBER",
            key: "quantity"
          };
        } else {
          await this.addMedicinesToPonds(updatePayload);
          await this.initComponent();
          this.dialogVisible = false;
          this.notifySuccess({
            msgLangkey: {
              title: "Comn_update_success_msg",
              count: 1,
              child: {
                item: name || resource_name,
                source: this.getSelectedPondName
              }
            }
          });
        }
      } catch (error) {
        let formatedError = {};
        if (
          error.response &&
          error.response.data.errors.details[0].error_code ===
            "RESOURCE_ALREADY_EXISTS"
        ) {
          formatedError = {
            type: "FAIL_TO_SAVE",
            errors: [{ message: this.$t("resource_already_exists") }]
          };
          this.errorMessages(formatedError, true);
        } else {
          formatedError = error;
        }
        this.errorMessages(formatedError, true);
      } finally {
        this.loading = false;
      }
    },
    async handleChangeResourceType(resourceType, type, data) {
      if (type === "type") {
        await this.fetchAllResources({
          type: resourceType,
          include_deleted: true
        });
        data.resource = "";
      } else {
        data.units = this.getArrResources.filter(
          res => res._id === data.resource._id
        )[0].units;
        // data.type = "";
      }
    },
    closeDialogBox() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss">
.pondInput_dialog {
  background: #fcfcfc;
  border-radius: 10px;
  .el-input--small .el-input__inner {
    @include responsiveProperty(width, 160px, 189px, 229px);
  }

  .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
    @include responsiveProperty(min-width, 105px, 100px, 140px);
  }
  .text-input-container {
    .el-input--small {
      @include responsiveProperty(width, 160px, 189px, 229px, true);
    }
  }
}
</style>
